import { TextSmall, Title } from "@finanedi.es/front/common/atoms"
import {
  DocumentosViewerModal,
  TurboForm,
} from "@finanedi.es/front/common/organisms"

import { useLeyAntifraudeFormRepresentantesFormTemplate } from "./hooks"
import { ILeyAntifraudeFormRepresentantesFormTemplateProps } from "./interfaces"
import { TLeyAntifraudeFormHeader } from "./templates"

export const LeyAntifraudeFormRepresentantesFormTemplate = ({
  nif,
  razonSocial,
}: ILeyAntifraudeFormRepresentantesFormTemplateProps) => {
  const { pdfModal, ...formProps } =
    useLeyAntifraudeFormRepresentantesFormTemplate({
      nif,
      razonSocial,
    })

  return (
    <div className='fs-col-span-12 fs-flex fs-flex-col'>
      <TLeyAntifraudeFormHeader />
      <div className='fs-flex fs-flex-col fs-gap-4'>
        <TurboForm {...formProps} />
        <TextSmall text='Rellena todos los datos de todos los representantes para activar la descarga.' />
      </div>

      {pdfModal.open && pdfModal.pdf && (
        <DocumentosViewerModal
          isOpen={pdfModal.open}
          onClose={pdfModal.onClose}
          pdf={pdfModal.pdf}
          className='fs-w-full fs-h-full desktop:fs-max-w-[50%] desktop:fs-max-h-[90%]'
          header={<Title text='Modelo de otorgamiento' />}
        />
      )}
    </div>
  )
}
